import React, { useState, useEffect } from 'react';
import { formatMobileDisplay, parseMobileInput, isValidMobileNumber } from '../../../utils/mobileNumberUtils';

const BookCabForm = () => {
  const [formValues, setFormValues] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile_number: '',
  });

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem('tripData'));
    if (savedData) {
        setFormValues({
        first_name: savedData.first_name || '',
        last_name: savedData.last_name || '',
        email: savedData.email || '',
        mobile_number: parseMobileInput(savedData.mobile_number || savedData.phone_number || ''),
      });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const isMobile = name === 'mobile_number';
    const updatedValues = {
      ...formValues,
      [name]: isMobile ? parseMobileInput(value) : value,
    };
    setFormValues(updatedValues);

    const currentTripData = JSON.parse(localStorage.getItem('tripData')) || {};
    const updatedTripData = {
      ...currentTripData,
      ...updatedValues,
    };
    localStorage.setItem('tripData', JSON.stringify(updatedTripData));
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-8 pb-4 border-b border-[#e2ebe8]">
        <h3 className="text-[24px] font-black text-[#1a1a1a] flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[#21A5A0]/10 flex items-center justify-center">
            <svg className="w-5 h-5 text-[#21A5A0]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          Traveller Info
        </h3>
        <span className="text-[#F5A623] text-[10px] font-black tracking-widest uppercase bg-[#FFF6E9] px-3 py-1.5 rounded-lg border border-[#FDE5C0]">
          Required
        </span>
      </div>

      <div className="space-y-6">
        {/* Row 1: Name */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label className="block text-[12px] font-bold text-[#6b7280] uppercase tracking-wider pl-1">First Name *</label>
            <input
              type="text"
              name="first_name"
              className="w-full px-5 py-3.5 rounded-xl border border-gray-200 outline-none text-[#1a1a1a] text-[15px] font-medium placeholder:text-gray-400 placeholder:font-normal focus:border-[#21A5A0] focus:ring-4 focus:ring-[#21A5A0]/10 transition-all bg-white"
              value={formValues.first_name}
              placeholder="e.g. Rahul"
              onChange={handleChange}
              required
            />
          </div>
          <div className="space-y-2">
            <label className="block text-[12px] font-bold text-[#6b7280] uppercase tracking-wider pl-1">Last Name *</label>
            <input
              type="text"
              name="last_name"
              className="w-full px-5 py-3.5 rounded-xl border border-gray-200 outline-none text-[#1a1a1a] text-[15px] font-medium placeholder:text-gray-400 placeholder:font-normal focus:border-[#21A5A0] focus:ring-4 focus:ring-[#21A5A0]/10 transition-all bg-white"
              placeholder="e.g. Sharma"
              value={formValues.last_name}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Row 2: Email */}
        <div className="grid grid-cols-1 md:grid-cols-[1.5fr_1fr] gap-6">
          <div className="space-y-2">
            <label className="block text-[12px] font-bold text-[#6b7280] uppercase tracking-wider pl-1">Email Address *</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <input
                type="email"
                name="email"
                className="w-full pl-12 pr-5 py-3.5 rounded-xl border border-gray-200 outline-none text-[#1a1a1a] text-[15px] font-medium placeholder:text-gray-400 placeholder:font-normal focus:border-[#21A5A0] focus:ring-4 focus:ring-[#21A5A0]/10 transition-all bg-white"
                placeholder="rahul.sharma@example.com"
                value={formValues.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row 3: Phone */}
          <div className="space-y-2">
            <label className="block text-[12px] font-bold text-[#6b7280] uppercase tracking-wider pl-1">Phone Number *</label>
            <div
              className={`flex items-center w-full rounded-xl bg-white border transition-all overflow-hidden ${
                isValidMobileNumber(formValues.mobile_number)
                  ? "border-[#10B981] ring-4 ring-[#10B981]/10"
                  : formValues.mobile_number.length > 0
                  ? "border-[#EF4444] ring-4 ring-[#EF4444]/10"
                  : "border-gray-200 focus-within:border-[#21A5A0] focus-within:ring-4 focus-within:ring-[#21A5A0]/10"
              }`}
            >
              <div className="flex shrink-0 items-center pl-4 pr-3.5 h-[50px] border-r border-gray-200 bg-[#f9fafb]">
                <img src="https://flagcdn.com/w20/in.png" alt="India Flag" className="w-[18px] opacity-90 mr-2" />
                <span className="text-[#1a1a1a] font-bold text-[14px]">+91</span>
              </div>
              <input
                type="tel"
                name="mobile_number"
                className="flex-1 min-w-0 h-[50px] px-4 outline-none text-[#1a1a1a] text-[15px] font-medium bg-transparent placeholder:text-gray-400 placeholder:font-normal"
                placeholder="98989 89811"
                value={formatMobileDisplay(formValues.mobile_number)}
                onChange={handleChange}
                maxLength={11}
                required
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookCabForm;